const translations = {
  // Navbar
  "nav.home": "Inicio",
  "nav.services": "Servicios",
  "nav.products": "Productos",
  "nav.whatsapp": "WhatsApp",
  "nav.quote": "Solicitar Cotización",
  "nav.whatsapp_full": "Hablar por WhatsApp",

  // Hero
  "hero.badge": "Más de 30 años de experiencia en impresión",
  "hero.title1": "Personalización profesional que hace",
  "hero.title2": "destacar tu marca",
  "hero.subtitle": "Especialistas en impresión DTF, sublimación y soluciones comerciales. Calidad superior en camisetas, gorras, tazas y más — listos para elevar tu negocio.",
  "hero.cta_quote": "Solicitar Cotización",
  "hero.cta_whatsapp": "Escribir por WhatsApp",
  "hero.cta_contact": "Contáctanos",
  "hero.stat1": "Años de experiencia",
  "hero.stat2": "Años como empresa",
  "hero.stat3": "Calidad garantizada",
  "hero.scroll": "Descubre más",

  // Services
  "services.tag": "Lo que hacemos",
  "services.title": "Nuestros Servicios Profesionales",
  "services.subtitle": "Soluciones completas de personalización e impresión para negocios que quieren destacar su marca.",
  "services.dtf.title": "Impresión DTF",
  "services.dtf.desc": "Tecnología de transferencia directa a tela con colores vibrantes y durabilidad excepcional. Ideal para camisetas, hoodies y cualquier prenda textil.",
  "services.dtf.badge": "Alta durabilidad",
  "services.sub.title": "Sublimación",
  "services.sub.desc": "Personalización permanente en tazas, botellas, artículos rígidos y prendas de poliéster. Colores que no se desvanecen con el tiempo.",
  "services.sub.badge": "Colores permanentes",
  "services.com.title": "Impresión Comercial",
  "services.com.desc": "Flyers, tarjetas de presentación, banners y material publicitario de alta calidad para impulsar tu negocio y fortalecer tu marca.",
  "services.com.badge": "Branding profesional",
  "services.micro.title": "Microperforados",
  "services.micro.desc": "Viniles microperforados para vehículos, vitrinas y negocios. Publicidad exterior de alto impacto con visibilidad desde el interior.",
  "services.micro.badge": "Publicidad exterior",
  "services.cta": "Solicitar Cotización",

  // Products
  "products.tag": "Catálogo",
  "products.title": "Productos que Transforman tu Marca",
  "products.subtitle": "Desde prendas hasta artículos promocionales, personalizamos todo con la más alta calidad.",
  "products.cta": "Cotizar",
  "products.view_all": "Ver Catálogo Completo",
  "products.cat.all": "Todos",
  "products.cat.textiles": "Textiles",
  "products.cat.caps": "Gorras",
  "products.cat.drinkware": "Drinkware",
  "products.cat.promo": "Promocionales",
  "products.not_found": "¿No encuentras lo que buscas?",
  "products.not_found_sub": "Contáctanos y personalizamos cualquier producto para tu marca.",

  // Value
  "value.tag": "Por qué elegirnos",
  "value.title": "Experiencia que Habla por Sí Sola",
  "value.stat1.label": "Años de experiencia",
  "value.stat1.desc": "Décadas de conocimiento en el sector de impresión y personalización.",
  "value.stat2.label": "Años como empresa",
  "value.stat2.desc": "Printven LLC establecida y creciendo con clientes satisfechos.",
  "value.stat3.label": "Compromiso con calidad",
  "value.stat3.desc": "Cada proyecto recibe nuestra máxima atención y estándares de calidad.",
  "value.tag2": "Nuestros valores",
  "value.title2": "Calidad, Compromiso y Experiencia",
  "value.subtitle2": "Más de 30 años de experiencia acumulada nos respaldan en cada proyecto que emprendemos.",
  "value.v1.title": "Calidad Superior",
  "value.v1.desc": "Utilizamos los mejores materiales y tecnologías para garantizar resultados excepcionales en cada pedido.",
  "value.v2.title": "Cumplimiento Puntual",
  "value.v2.desc": "Respetamos los tiempos de entrega acordados porque sabemos que tu negocio no puede esperar.",
  "value.v3.title": "Atención Personalizada",
  "value.v3.desc": "Cada cliente recibe atención dedicada desde la cotización hasta la entrega final del producto.",
  "value.v4.title": "Garantía Total",
  "value.v4.desc": "Respaldamos cada producto con nuestra garantía de satisfacción. Tu confianza es nuestra prioridad.",

  // Commercial
  "commercial.tag": "Soluciones Comerciales",
  "commercial.title": "Impulsa tu negocio con material de impresión profesional",
  "commercial.desc": "Desde tarjetas de presentación hasta microperforados para vehículos, ofrecemos soluciones completas de impresión comercial que fortalecen la imagen de tu marca.",
  "commercial.i1.title": "Flyers de Alto Impacto",
  "commercial.i1.desc": "Diseños llamativos que capturan la atención de tu audiencia.",
  "commercial.i2.title": "Tarjetas de Presentación",
  "commercial.i2.desc": "Primera impresión profesional que deja huella en tus clientes.",
  "commercial.i3.title": "Material Publicitario",
  "commercial.i3.desc": "Banners, posters y material de branding para tu negocio.",
  "commercial.i4.title": "Microperforados",
  "commercial.i4.desc": "Para vehículos, vitrinas y espacios comerciales con visibilidad total.",
  "commercial.cta": "Solicitar Cotización Comercial",
  "commercial.quality": "Impresión Comercial",
  "commercial.quality_sub": "Calidad profesional garantizada",

  // CTA
  "cta.title": "¿Listo para hacer destacar tu marca?",
  "cta.subtitle": "Obtén una cotización personalizada en minutos. Más de 30 años de experiencia respaldan cada producto que entregamos.",
  "cta.btn1": "Solicitar Cotización Ahora",
  "cta.btn2": "Hablar por WhatsApp",
  "cta.tag": "Empieza hoy",

  // Services Page
  "svcpage.tag": "Lo que ofrecemos",
  "svcpage.title": "Servicios Profesionales de Impresión",
  "svcpage.subtitle": "Más de 30 años de experiencia respaldan cada servicio que ofrecemos. Calidad, precisión y cumplimiento en cada proyecto.",
  "svcpage.cta_title": "¿Tienes un proyecto en mente?",
  "svcpage.cta_sub": "Contáctanos hoy y recibe una cotización personalizada sin compromiso.",
  "svcpage.quote": "Solicitar Cotización",
  "svcpage.whatsapp": "WhatsApp",

  // Products Page
  "prodpage.tag": "Catálogo",
  "prodpage.title": "Productos Personalizables",
  "prodpage.subtitle": "Explora nuestro catálogo completo. Cada producto puede ser personalizado con tu marca, logo o diseño.",
  "prodpage.quote": "Solicitar Cotización",
  "prodpage.not_found": "¿No encuentras lo que buscas?",
  "prodpage.not_found_sub": "Contáctanos y personalizamos cualquier producto para tu marca.",
  "prodpage.whatsapp": "Hablar por WhatsApp",

  // Navbar extra
  "nav.about": "Nosotros",
  "nav.contact": "Contacto",

  // CTA shared
  "cta.quote": "Solicitar Cotización",
  "cta.whatsapp": "Hablar por WhatsApp",

  // About Page
  "about.badge": "Nuestra Historia",
  "about.hero_title": "Más de 30 años imprimiendo calidad y confianza",
  "about.hero_subtitle": "Somos Printven LLC, una empresa especializada en personalización de productos con más de 5 años en el mercado y más de 30 años de experiencia acumulada en el sector.",
  "about.stat1": "Años de experiencia",
  "about.stat2": "Años como empresa",
  "about.stat3": "Clientes satisfechos",
  "about.stat4": "Compromiso con calidad",
  "about.story_badge": "Nuestra historia",
  "about.story_title": "De la pasión por la impresión a una empresa de referencia",
  "about.story_p1": "Printven LLC nació de décadas de experiencia acumulada en el sector de la impresión y personalización. Desde nuestros inicios, nos hemos dedicado a ofrecer soluciones de alta calidad que ayudan a negocios y emprendedores a destacar su marca.",
  "about.story_p2": "Con más de 30 años de conocimiento en el sector, hemos adoptado las tecnologías más avanzadas como la impresión DTF y la sublimación, manteniéndonos siempre a la vanguardia de la industria.",
  "about.story_p3": "Hoy, desde Indianapolis, IN, servimos a clientes en toda la región con el mismo compromiso de calidad, cumplimiento y atención personalizada que nos ha caracterizado desde el primer día.",
  "about.years_exp": "Años de experiencia",
  "about.timeline_badge": "Nuestra trayectoria",
  "about.timeline_title": "Un camino de crecimiento constante",
  "about.m1_title": "Los inicios en impresión",
  "about.m1_desc": "Comenzamos nuestra trayectoria en el sector de la impresión y personalización, acumulando conocimiento y experiencia que se convertiría en nuestra mayor fortaleza.",
  "about.m2_title": "Expansión de servicios",
  "about.m2_desc": "Incorporamos nuevas tecnologías y ampliamos nuestra oferta de servicios para atender las crecientes necesidades del mercado de personalización.",
  "about.m3_title": "Fundación de Printven LLC",
  "about.m3_desc": "Con más de 25 años de experiencia acumulada, fundamos Printven LLC en Indianapolis, IN, para ofrecer servicios profesionales de impresión DTF, sublimación y más.",
  "about.m4_title": "Líderes en personalización",
  "about.m4_desc": "Hoy somos referentes en el sector, con tecnología de punta, un equipo comprometido y cientos de clientes satisfechos que confían en nuestra calidad.",
  "about.values_badge": "Lo que nos define",
  "about.values_title": "Nuestros Valores",
  "about.v1_title": "Calidad sin compromiso",
  "about.v1_desc": "Cada producto que sale de nuestras instalaciones cumple con los más altos estándares de calidad.",
  "about.v2_title": "Puntualidad garantizada",
  "about.v2_desc": "Cumplimos con los tiempos de entrega acordados porque respetamos tu tiempo y tu negocio.",
  "about.v3_title": "Atención al cliente",
  "about.v3_desc": "Acompañamos a cada cliente desde la primera consulta hasta la entrega final con dedicación total.",
  "about.v4_title": "Innovación constante",
  "about.v4_desc": "Adoptamos las últimas tecnologías para ofrecer siempre las mejores soluciones del mercado.",
  "about.commitment_badge": "Nuestro compromiso",
  "about.commitment_title": "Tu éxito es nuestro objetivo",
  "about.commitment_p1": "En Printven LLC entendemos que cada producto personalizado es una extensión de tu marca. Por eso tratamos cada pedido con la misma dedicación y cuidado, sin importar el tamaño.",
  "about.commitment_p2": "Nuestro equipo está listo para asesorarte, ayudarte a elegir el mejor método de impresión y garantizar que el resultado final supere tus expectativas.",

  // Contact Page
  "contact.badge": "Estamos aquí para ayudarte",
  "contact.hero_title": "Hablemos de tu próximo proyecto",
  "contact.hero_subtitle": "Solicita tu cotización personalizada o escríbenos por WhatsApp. Respondemos rápido.",
  "contact.info_title": "Información de contacto",
  "contact.info_desc": "Estamos disponibles para atenderte y responder todas tus preguntas sobre nuestros servicios.",
  "contact.info_phone": "Teléfono",
  "contact.info_location": "Ubicación",
  "contact.info_whatsapp": "WhatsApp",
  "contact.wa_title": "¿Prefieres WhatsApp?",
  "contact.wa_desc": "Escríbenos directamente y recibe respuesta en minutos.",
  "contact.form_title": "Solicita tu Cotización",
  "contact.form_desc": "Completa el formulario y te contactamos a la brevedad con una propuesta personalizada.",
  "contact.field_name": "Nombre completo",
  "contact.field_email": "Correo electrónico",
  "contact.field_phone": "Teléfono",
  "contact.field_service": "Servicio de interés",
  "contact.field_message": "Mensaje",
  "contact.placeholder_name": "Tu nombre completo",
  "contact.placeholder_email": "tu@email.com",
  "contact.placeholder_phone": "+1 (000) 000-0000",
  "contact.select_service": "Selecciona un servicio...",
  "contact.placeholder_message": "Cuéntanos sobre tu proyecto, cantidad, tipo de producto...",
  "contact.submit": "Enviar Solicitud",
  "contact.sending": "Enviando...",
  "contact.success_title": "¡Mensaje enviado!",
  "contact.success_desc": "Gracias por contactarnos. Te responderemos a la brevedad con tu cotización personalizada.",
  "contact.send_another": "Enviar otro mensaje",
  "contact.error_msg": "Hubo un error al enviar. Por favor intenta de nuevo.",

  // Footer
  "footer.tagline": "Personalización profesional desde 2019",
  "footer.nav": "Navegación",
  "footer.services": "Servicios",
  "footer.contact": "Contacto",
  "footer.chat": "Chatea con nosotros",
  "footer.rights": "Todos los derechos reservados.",
};

export default translations;
